// Kassa ekranining kesh kalitlari.
//
// NEGA BIR JOYDA (admin panelidagi `shared/api/queryKeys.ts` bilan bir
// xil sabab): keshni bekor qilish PREFIKS bo'yicha ishlaydi. Kalitlar
// chaqiruv joylarida qo'lda yozilsa, biri `['cashdesk']`, ikkinchisi
// `['cash-search']` deb yozadi va bekor qilish JIMGINA ishlamay qoladi
// — ekranda esa eskirgan PUL SUMMASI qoladi.
//
// `as const` MUHIM: kalit tuple sifatida tiplanadi va noto'g'ri
// argument kompilyatsiyada ushlanadi.

export const cashdeskKeys = {
  all: ['cashdesk'] as const,
  /** ⚠️ Qidiruv so'zi KALITDA — usiz oldingi so'rov natijasi ekranda qolardi */
  search: (query: string) => ['cashdesk', 'search', query] as const,
  /** Kassirning o'z tuguni — sessiya davomida o'zgarmaydi */
  agents: ['cashdesk', 'agents'] as const,
  /** ⚠️ `agents` DAN ALOHIDA: depozit har amaldan keyin eskiradi, tugun esa yo'q */
  balance: (agentId: string) => ['cashdesk', 'balance', agentId] as const,
  /** Sotiladigan paketlar katalogi — kamdan-kam o'zgaradi */
  plans: ['cashdesk', 'plans'] as const,
  /**
   * Bitta to'lovning shifti (`PER_TXN`).
   *
   * ⚠️ `balance` DAN ALOHIDA: shift amaldan keyin O'ZGARMAYDI (u
   * hisoblagich emas, shartnoma sozlamasi), depozit esa har amalda
   * o'zgaradi. Bir kalitga qo'shilsa har to'lovdan keyin ortiqcha
   * so'rov ketardi.
   */
  perTxnLimit: (agentId: string) => ['cashdesk', 'perTxnLimit', agentId] as const,
} as const
